/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hero-section[_ngcontent-%COMP%]{position:relative;min-height:calc(100vh - 70px);display:flex;align-items:center;flex:0 0 100%;flex-wrap:wrap;max-width:100%;overflow:hidden}.hero-section[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]{z-index:10}.hero-section[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:.7rem;letter-spacing:2px;text-transform:uppercase}.hero-section[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{display:block;margin-bottom:10px;font-weight:900}"];
export { styles as styles };
